module.exports = __webpack_public_path__ + "img/inspect_0.0beddbb4.png";